import { render } from "./travels.vue?vue&type=template&id=33e37d85&scoped=true"
import script from "./travels.vue?vue&type=script&lang=js"
export * from "./travels.vue?vue&type=script&lang=js"

import "./travels.vue?vue&type=style&index=0&id=33e37d85&scoped=true&lang=css"

import exportComponent from "/opt/buildhome/repo/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-33e37d85"]])

export default __exports__